/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';

import Breadcrumbs from '../../atoms/Breadcrumbs/Breadcrumbs';

import TimeMachine from '../../atoms/TimeMachine/TimeMachine';
import Settings from '../../atoms/Settings/Settings';
import { EStyleObj } from '../../../types';
import { useIsSuperuser } from '~src/hooks/useIsSuperuser';
import { useProjectId } from '~src/hooks/useProjectId';
import { SearchBar } from '~components/atoms/SearchBar/SearchBar';
import BigLogo from '~src/assets/c-web-logo-darkgray.png';
import SmallLogo from '~src/assets/favicon72.png';

import SidebarContext from '~src/contexts/SidebarContext';
import { useContext } from 'react';
import { useIsOnStart } from '~src/hooks/useIsOnStart';
import { useIsUserAuthenticated } from '~src/hooks/api-hooks/useUserSettings';

type AboveNavProps = {
  publicPage?: boolean;
};

const style: EStyleObj = {
  component: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 6px',
    height: '50px',
    minWidth: 100,
  },
  aboveNaveButtons: {
    display: 'flex',
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',

    margin: '0 auto',
  },
};

const AboveNav: React.FC<AboveNavProps> = ({ publicPage }) => {
  const isSuperUser = useIsSuperuser();
  const { isSidebarMinimized } = useContext(SidebarContext);

  const hasProjectIdInUrl = window.location.href.includes('projectId=');
  const projectId = useProjectId();
  const isAuthenticated = useIsUserAuthenticated();
  const isOnMyProjectsView = window.location.pathname.startsWith(
    '/my-projects/'
  );
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const isOnArchivePath = pathParts.includes('archive');
  const isOnSearchPath = pathParts.includes('search');
  const searchPublicPage = !isOnArchivePath && !isOnSearchPath;

  return (
    <div css={style.component}>
      <div
        style={{ width: isSidebarMinimized ? 'auto' : '263px' }}
        css={style.logoContainer}>
        <img
          src={isSidebarMinimized ? SmallLogo : BigLogo}
          alt=""
          width={isSidebarMinimized ? '50' : '140'}
        />
      </div>
      <div
        style={{
          display: 'flex',
          width: isSidebarMinimized ? '93.3%' : '80%',
          justifyContent: 'flex-end',
        }}>
        <Breadcrumbs />
        <SearchBar publicPage={searchPublicPage} />

        <div css={style.aboveNaveButtons}>
          {window.sessionStorage.getItem('appState') !== 'superUser' &&
            isAuthenticated &&
            projectId &&
            !hasProjectIdInUrl &&
            !isOnMyProjectsView && <TimeMachine publicPage={publicPage} />}
          <Settings />
        </div>
      </div>
    </div>
  );
};

export default AboveNav;
